import React from 'react';
import { GetItemPropsOptions } from 'downshift';
import { IItem } from './interface';
import { stringifyItem } from './helpers';

interface IProps {
    index: number;
    highlightedIndex: number | null;
    getItemProps: (options: GetItemPropsOptions<IItem>) => IItem;
    item: IItem;
    selectedItem: IItem | null;
    ItemComponent: any;
}

export const DropdownItem = ({
    index,
    highlightedIndex,
    getItemProps,
    item,
    selectedItem,
    ItemComponent,
}: IProps) => {
    return (
        <ItemComponent
            isActive={highlightedIndex === index}
            {...getItemProps({
                item,
                index,
                isSelected: selectedItem ? selectedItem.key === item.key : false,
            })}
        >
            {stringifyItem(item)}
        </ItemComponent>
    );
};
